import type { InfringementExportRow } from 'src/context/api/brandInfringement/api';

const CSV_COLUMNS: [string, (r: InfringementExportRow) => string | null][] = [
    ['Region', (r) => r.region_name],
    ['Domain', (r) => r.domain_name],
    ['Trademark Report URL', (r) => r.url],
    // No dedicated referral field on the API: reuse the URL (identical in the mockup).
    ['Trademark Report Referral URL', (r) => r.url],
    ['Trademark Report Title', (r) => r.title],
    ['Trademark Report Description', (r) => r.description],
];

const escapeCsv = (value: string | null): string => {
    let v = value ?? '';
    if (/^[=+\-@\t\r]/.test(v)) v = `'${v}`;
    return /[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
};

export const buildCsv = (rows: InfringementExportRow[]): string => [
    CSV_COLUMNS.map(([name]) => name).join(','),
    ...rows.map((row) => CSV_COLUMNS.map(([, get]) => escapeCsv(get(row))).join(',')),
].join('\n');

export const csvFilename = (workspaceName: string, domain?: string) =>
    domain
        ? `${workspaceName} - Trademark report for screenshot - ${domain}.csv`
        : `${workspaceName} - Trademark report.csv`;

export const htmlFilename = (workspaceName: string, domain: string) =>
    `${workspaceName} - Trademark report for screenshot - ${domain}.html`;

const UTF8_BOM = '\uFEFF';

export const downloadTextFile = (filename: string, content: string, mime: string) => {
    const blob = new Blob([`${UTF8_BOM}${content}`], { type: `${mime};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
